module.exports = __webpack_public_path__ + "img/img_default_empty@3x.3a84bc09.png";